import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../css/Commerce.css";
import CommerceSettings from "../component/Commerce/CommerceSettings";
import Autocheckout from "../component/Commerce/Autocheckout";
import Orderpannel from "../component/Commerce/Orderpannel";
import Catalog from "../component/Commerce/Catalog";

const Commerce = () => {
  const [selectedMenu, setSelectedMenu] = useState("commerce-settings");

  return (
    <div className="container-fluid p-0">
      <div className="bg-success text-white text-center commerce-header py-2">
        We've added sample products for you in sandbox mode. Please connect your
        own number to sync your own product catalogue.
      </div>
      <div className="d-flex">
        <div
          className="bg-light p-1 rounded shadow nav-commerce"
          style={{ width: "250px", minHeight: "100vh" }}
        >
          <p style={{ color: "grey" }}>Commerce</p>
          <ul className="list-unstyled">
            <li
              className={`p-2 commerce-nav ${
                selectedMenu === "commerce-settings" ? "selected" : ""
              }`}
              onClick={() => setSelectedMenu("commerce-settings")}
            >
              <i className="icon bi bi-gear-fill me-2"></i>
              Commerce Settings
            </li>
            <li
              className={`p-2 commerce-nav ${
                selectedMenu === "catalog" ? "selected" : ""
              }`}
              onClick={() => setSelectedMenu("catalog")}
            >
              <i className="icon bi bi-palette2 me-2"></i>
              Catalog
            </li>
            <li
              className={`p-2 commerce-nav ${
                selectedMenu === "order-panel" ? "selected" : ""
              }`}
              onClick={() => setSelectedMenu("order-panel")}
            >
              <i className="icon bi bi-graph-up me-2"></i>
              Order Panel
            </li>
            <li
              className={`p-2 commerce-nav ${
                selectedMenu === "Auto-checkout" ? "selected" : ""
              }`}
              onClick={() => setSelectedMenu("Auto-checkout")}
            >
              <i className="icon bi bi-basket2 me-2"></i>
              Auto Checkout Flow <i className="bi bi-box-arrow-up-right"></i>
            </li>
          </ul>
        </div>

        {/* Main Content */}
        <div className="p-3 flex-grow-1 commerce-body">
          {selectedMenu === "commerce-settings" && <CommerceSettings />}
          {selectedMenu === "catalog" && <Catalog />}
          {selectedMenu === "order-panel" && <Orderpannel />}
          {selectedMenu === "Auto-checkout" && <Autocheckout />}
        </div>
      </div>
    </div>
  );
};

export default Commerce;
